import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { map, Observable, of, SubscriptionLike, tap } from 'rxjs';
import { LoginData, ResponseError } from '../../../api';
import { itemUnsubscribe } from '../../../utils';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.sass'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class LoginFormComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;
  @Input() loading: Observable<boolean> = of(false);
  @Input() errors: Observable<ResponseError | null> = of(null);
  @Output() formSubmit = new EventEmitter<LoginData>();
  private subs: SubscriptionLike[] = [];

  get email(): any {
    return this.formGroup.get('email');
  }

  get password(): any {
    return this.formGroup.get('password');
  }

  get disabled(): Observable<boolean> {
    return this.loading.pipe(map(l => l || this.formGroup.invalid));
  }

  onFormSubmit = (): void => {
    if (this.formGroup.valid) {
      const value = this.formGroup.value;
      this.formSubmit.next(value);
    }
  };

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required]]
    });
    this.subs.push(this.errors.pipe(tap(e => {
      if (e?.name === 'Validation') {
        this.email?.markAsTouched();
        this.email?.setErrors({ error: true });
        this.password?.markAsTouched();
        this.password?.setErrors({ error: true });
      }
    })).subscribe());
  }

  ngOnDestroy(): void {
    itemUnsubscribe(this.subs);
  }

  constructor(private fb: FormBuilder) {
  }
}
